import { createRoot } from 'react-dom/client'
import App from './App.tsx'

//token auto-refresh logic is here. 
//call /token/refresh endpoint to refresh the token every 5 mins

const refreshToken = () => {
  fetch('/auth/refresh', {
    method: 'POST',
    credentials: 'include',
  })
  .then(response => {
    if (!response.ok) {
      console.error('Failed to refresh token');
    }
  })
  .catch(error => {
    console.error('Error refreshing token:', error);
  });
}

setInterval(refreshToken, 5 * 60 * 1000); // Refresh every 5 minutes

//also refresh token on page load (content visibility change event or newver api)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    refreshToken();
  }
});

createRoot(document.getElementById('app')!).render(  
  <App />,
)
